// The Slovenian texts are the prototype's own, word for word where a screen matches.
export default {
    offer: {
        save_hint: 'Megnyílik a nyomtatási ablak — PDF-hez válassza a „Mentés PDF-ként” célt.',
        invalid_title: 'Az ajánlat nem érhető el',
        invalid_text: 'Az ajánlat hivatkozása lejárt vagy megváltozott. Kérjük, forduljon a szállodához.',
        eyebrow: 'Csoportos ajánlat',
        eyebrow_reservation: 'Az Ön ajánlata',
        nights: 'éjszaka',
        financials: 'Ajánlat',
        col_item: 'Tétel',
        col_quantity: 'Mennyiség',
        col_price: 'Egységár',
        col_discount: 'Kedvezmény',
        col_vat: 'Áfa',
        col_amount: 'Összeg',
        total_net: 'Összesen áfa nélkül',
        vat_at: 'Áfa {rate} %',
        remaining: 'Fizetendő',
        rooms: 'Szállás',
        per_night: 'éj',
        up_to: 'legfeljebb {count} fő szobánként',
        total: 'Összesen',
        paid: 'Már fizetve',
        services: 'A szálloda szolgáltatásai',
        included: 'vendégek részére elérhető',
        valid_until: 'Az ajánlat érvényességi ideje: {date}.',
        contact: 'Kérdések és megerősítés',
        print: 'Nyomtatás',
        save: 'PDF mentése',
        confirm: 'Ajánlat megerősítése',
        confirmed_at: 'Ajánlat megerősítve: {date}. Köszönjük — a szálloda értesítést kapott.',
        units: { hour: 'óra', day: 'nap', night: 'éj', person: 'fő', use: 'alkalom', item: 'db', treatment: 'kezelés' },
    },
    rooming: {
        pick: 'Válasszon…',
        invalid_title: 'A hivatkozás érvénytelen',
        invalid_text: 'A vendégfelviteli hivatkozás lejárt vagy megváltozott. Kérjük, forduljon a szállodához.',
        intro: 'Adja meg a csoportja tagjait. A szálloda átnézi a listát és szobákba osztja őket — az itteni felvitel még nem jelent foglalást.',
        add_title: 'Vendég hozzáadása',
        first_name: 'Keresztnév',
        last_name: 'Vezetéknév',
        email: 'E-mail',
        phone: 'Telefon',
        notes: 'Megjegyzések',
        add: 'Hozzáadás',
        added: 'A vendég felkerült a listára.',
        failed: 'A felvitelt nem sikerült menteni.',
        entered: 'Felvitt vendégek ({count})',
        none_yet: 'Még nincs felvitt vendég.',
        booking_title: 'Útitársak felvitele',
        rooms_title: 'Szobák',
        rooms_count: '{count} szoba',
        filled_of: 'Felvitt: {filled} / {capacity}',
        pick_room_first: 'Először válasszon szobát fent.',
        adding_to: 'Hozzáadás ehhez: {room}',
        unassigned: 'Beosztás nélkül',
        date_of_birth: 'Születési dátum',
        nationality: 'Állampolgárság',
        nationality_hint: 'pl. SI',
        document_type: 'Okmány típusa',
        document_type_hint: 'pl. útlevél',
        document_number: 'Okmány száma',
        confirmed: 'Megerősítve',
        booked_note: 'A már beosztott vendégeket a szálloda megerősítette; a változásokat kérjük jelezze a recepción.',
        register_hint: 'A születési dátum, az állampolgárság és az okmány a vendég törvény szerinti bejelentéséhez szükséges. Az adatokat a recepción érkezéskor ellenőrizzük.',
    },
    keys: {
        title: 'Kulcsok',
        your_room: 'AZ ÖN SZOBÁJA',
        your_pin: 'AZ ÖN PIN-KÓDJA',
        pin_text: 'A PIN-kóddal minden ajtaját kinyithatja, vagy használhatja az alábbi távoli nyitást.',
        your_keys: 'AZ ÖN KULCSAI',
        door_room: 'Szoba',
        room_on_arrival: 'érkezéskor kerül kiosztásra',
        hold: 'Tartsa lenyomva a nyitáshoz',
        unlocked: 'Kinyitva',
        preview_note: 'A távoli nyitás akkor kezd működni, amikor a szálloda összekapcsolja a zárakat a rendszerrel — addig ez csak előnézet.',
        demo_done: 'Előnézet — a zárak még nincsenek összekapcsolva.',
    },
    nav: {
        menu: 'Menü',
        roomservice_hint: 'Ételek és italok egyenesen a szobába',
        roomservice: 'Szobaszerviz',
        keys: 'Kulcsok',
        short_keys: 'Kulcsok',
        overview: 'Áttekintés',
        checkin: 'Bejelentkezés',
        stay: 'Tartózkodásom',
        arrival: 'Ideutazás',
        services: 'Szolgáltatások',
        payments: 'Fizetések és számlák',
        short_overview: 'Kezdőlap',
        short_checkin: 'Bejelentkezés',
        short_arrival: 'Érkezés',
        short_services: 'Szolgáltatások',
        short_payments: 'Számla',
        house: 'A szálloda',
    },
    general: {
        back: 'Vissza',
        cancel: 'Mégse',
        close: 'Bezárás',
        save_failed: 'A mentés nem sikerült. Próbálja újra.',
    },
    theme: {
        title: 'Világos/sötét téma',
        to_dark: 'Sötét téma bekapcsolása',
        to_light: 'Világos téma bekapcsolása',
    },
    overview: {
        eyebrow: 'A KÖVETKEZŐ TARTÓZKODÁSA',
        language: 'Nyelv',
        welcome: 'Üdvözöljük itt:',
        welcome_named: 'Üdvözöljük, {names}',
        and: 'és',
        subtitle: 'Itt intézhet mindent az érkezés előtt és a tartózkodás alatt.',
        arrival: 'ÉRKEZÉS',
        departure: 'TÁVOZÁS',
        reservation: 'FOGLALÁS',
        ready: 'Készen áll az érkezésre',
        almost: 'Készen áll az érkezésre',
        all_done: 'Minden elrendezve',
        one_more_step: 'Még egy lépés',
        steps_left_two: 'Még 2 lépés',
        steps_left_few: 'Még {n} lépés',
        step_profile: 'Személyes adatok',
        step_document: 'Okmány',
        step_payment: 'Fizetés',
        finish_checkin: 'Bejelentkezés befejezése',
        card_checkin: 'Online bejelentkezés',
        card_checkin_text: 'Töltse ki a vendégek adatait, és rövidítse le a recepciós ügyintézést.',
        card_checkin_go: 'Bejelentkezés folytatása',
        card_stay: 'Tartózkodásom',
        card_stay_text: 'Szoba, érkezési idő, különleges kérések és érkezési útmutató.',
        card_stay_go: 'Foglalás megtekintése',
        card_services: 'Szállodai szolgáltatások',
        card_services_text: 'Masszázs, szauna, vacsora vagy kerékpárkölcsönzés.',
        card_services_go: 'Szolgáltatások felfedezése',
        card_room_service: 'Szobaszerviz',
        card_room_service_text: 'Ételek és italok a szálloda konyhájából, egyenesen a szobába.',
        card_room_service_go: 'Az étlaphoz',
        card_money: 'Költségek és fizetések',
        card_money_go: 'Számla és fizetés megnyitása',
        card_keys_title: 'Kulcsok',
        card_keys_none: 'A kulcs és a PIN-kód a bejelentkezés és a szoba kiosztása után várja Önt.',
        card_keys_get: 'Kulcs igénylése',
        card_keys_go: 'Összes kulcs és PIN',
        card_arrival: 'Érkezés és helyszín',
        card_arrival_text: 'Cím, navigáció, valamint a bejárat, a parkoló és a garázs fényképei.',
        card_arrival_go: 'Érkezési útmutató megtekintése',
        card_house: 'A szálloda és a környék',
        card_house_text: 'Wi-Fi, nyitvatartás, üdvözlőlevél, árlista és városi programok.',
        card_house_go: 'Szállodai információk megnyitása',
        partly_paid: 'Részben fizetve',
        charges: 'Tartózkodási költségek',
        parking_charges: 'Parkolási költségek',
        paid: 'Fizetve',
        balance: 'Fennmaradó összeg',
    },
    checkin: {
        pick: 'Válasszon…',
        title: 'Online bejelentkezés',
        subtitle: 'Az adatok biztonságosan, közvetlenül a szállodához kerülnek.',
        step_guests: 'Vendégek',
        step_documents: 'Okmányok',
        step_payment: 'Fizetés',
        step_confirm: 'Megerősítés',
        guests_title: 'A foglaláson szereplő vendégek',
        unnamed: 'Névtelen vendég',
        document_read: 'Okmány beolvasva · az adatok teljesek',
        document_missing: 'Hiányzó okmány',
        document_entered: 'Adatok megadva · a recepció érkezéskor ellenőrzi',
        done_badge: 'Kész',
        add_document: 'Adatok megadása',
        add_companion: 'Kísérő hozzáadása',
        first_name: 'Keresztnév',
        last_name: 'Vezetéknév',
        companion_hint: 'Adjon hozzá egy Önnel tartózkodó személyt. Az okmányát a következő lépésben adhatja meg, ugyanúgy, mint a sajátját.',
        companion_room: 'Szoba',
        companion_save: 'Személy hozzáadása',
        companion_saved: 'A személy hozzáadva — most adja meg az okmányát is.',
        companion_incomplete: 'Adja meg a kereszt- és vezetéknevet (és válasszon szobát).',
        companion_failed: 'A személyt nem sikerült hozzáadni — lehet, hogy a szoba már megtelt. Kérjük, forduljon a recepcióhoz.',
        wishes_title: 'Érkezés és kérések',
        expected_arrival: 'Várható érkezés',
        phone: 'Mobilszám',
        phone_placeholder: '+386 41 234 567',
        wishes: 'Különleges kérések',
        wishes_placeholder: 'Csendes szoba, magasabb emelet',
        plate: 'Rendszám',
        plate_hint: 'Ha az autót a parkolóban vagy a garázsban parkolja.',

        // Marketing consent (docs/MARKETING.md §13). Never pre-ticked.
        consent_title:  'Ajánlatok e-mailben',
        consent_label:  'Szeretném megkapni a szálloda ajánlatait és híreit e-mailben.',
        consent_hint:   'Bármikor visszavonhatja — akár egy kattintással minden levél alján. A foglalásával kapcsolatos üzenetek ettől függetlenül megérkeznek.',
        consent_failed: 'A hozzájárulást nem sikerült menteni.',
        save_for_later: 'Mentés későbbre',
        continue_payment: 'Tovább a fizetéshez',
        saved: 'A bejelentkezés mentve.',
        doc_title: 'Okmány hozzáadása',
        doc_type: 'Okmány típusa',
        doc_number: 'Okmány száma',
        doc_nationality: 'Állampolgárság',
        doc_nationality_hint: 'Kétbetűs országkód, pl. SI, DE, IT.',
        doc_birth: 'Születési dátum',
        doc_save: 'Adatok mentése',
        doc_saved: 'Az okmány mentve.',
        doc_incomplete: 'Töltsön ki minden mezőt — nélkülük a vendég nem jelenthető be.',
        doc_hint: 'Olvassa be az okmányt az Imprion ID Scan alkalmazással, vagy adja meg az adatokat kézzel. A fénykép nem kerül mentésre.',
        doc_manual: 'Kézi bevitel',
        doc_idscan: 'ID Scan megnyitása',
        doc_coming: 'Az okmány beolvasása a portálon keresztül hamarosan érkezik — addig a recepción olvassák be.',
    },
    stay: {
        requests_title: 'AZ ÖN KÉRÉSEI',
        request_extension: 'Hosszabbítás {nights} éjszakával',
        request_late_checkout: 'Késői kijelentkezés',
        request_pending: 'a recepcióra vár',
        request_confirmed: 'megerősítve',
        request_declined: 'sajnos nem lehetséges',
        title: 'Tartózkodásom',
        room: 'Szoba',
        room_assigned_on_arrival: 'A szoba érkezéskor kerül kiosztásra',
        occupancy: '{adults} felnőtt · {children} gyermek',
        expected: 'várható {hour}',
        late_checkout: 'Kései kijelentkezés kérése',
        room_released_title: 'Távozás a szobából',
        room_released_text: 'Kijelentkezett, a szobát azonban nálunk még foglaltként tartjuk nyilván. Amint jelzi, hogy elhagyta, előkészíthetjük a következő vendégnek.',
        room_released: 'Elhagytam a szobát',
        room_released_sent: 'Köszönjük - jeleztük, hogy a szoba szabad.',
        extension_check: 'Lehetséges hosszabbítás ellenőrzése',
        extension_title: 'Tartózkodás meghosszabbítása',
        extension_hint: 'Ellenőrizze, hogy a távozása utáni éjszakák még szabadok-e. A kérés a recepcióhoz kerül, amely megerősíti a hosszabbítást — semmi sem foglalódik le magától.',
        extension_same_room: 'Szabad — ugyanabban a szobában maradhat',
        extension_other_room: 'Szabad — szobacserével',
        extension_full: 'Sajnos ezekre az éjszakákra nincs szabad szoba.',
        extension_price: 'becslés {amount}/éj az Ön csomagja szerint',
        extension_request: '+{nights} kérése',
        extension_sent: 'A hosszabbítási kérés a recepcióhoz került — visszajelzést fognak adni.',
        late_checkout_sent: 'A kései kijelentkezés kérése elküldve.',
        call: 'Hívás',
        status_booked: 'Lefoglalva',
        status_confirmed: 'Megerősítve',
        status_checked_in: 'Bejelentkezve',
        status_checked_out: 'Kijelentkezve',
    },
    parking: {
        maps_card: 'Helyszín és navigáció a Google Térképen',
        card_title: 'Parkolás',
        card_title_both: 'Parkolás és garázs',
        card_text: 'Adja meg a rendszámot, hogy a sorompó érkezéskor és a tartózkodás alatt automatikusan kinyíljon.',
        add: 'Rendszám hozzáadása',
        change: 'Hozzáférés módosítása vagy hozzáadása',
        active_badge: 'Sorompó aktív',
        active_until: 'Az automatikus behajtás eddig aktív: {date}.',
        title: 'Automatikus garázsbehajtás',
        hint: 'A sorompónál lévő kamera a tartózkodás alatt felismeri a rendszámot, és automatikusan kinyitja a sorompót.',
        maps: 'Megnyitás a Google Térképen',
        copy: 'Cím másolása',
        copied: 'A cím másolva.',
        plate: 'Jármű rendszáma',
        placeholder: 'pl. MB AB-123',
        validity: 'Hozzáférés érvényessége',
        validity_range: '{from} – {to}',
        activate: 'Megerősítés és aktiválás',
        activated: 'A(z) {plate} rendszám aktiválva az automatikus behajtáshoz.',
        check_plate: 'Ellenőrizze a rendszámot.',
        extra_cars: 'További járművek',
        add_car: 'További autó hozzáadása',
        remove_car: 'Eltávolítás',
        removed: 'A rendszám eltávolítva; a sorompó többé nem nyílik ki neki.',
        removed_booking_kept: 'A rendszám eltávolítva. A parkolóhely-foglalás a portálon keresztül már nem mondható le — a recepció intézi.',
        first_car_price: 'Parkolóhely a tartózkodásra: {amount}. Az összeg a tartózkodás számlájára kerül.',
        included_note: 'A parkolás az éjszaka árában benne van.',
        remove_car_done: 'A(z) {plate} foglalása lemondva és levonva a tartózkodás számlájáról.',
        add_car_price: 'Parkolóhely a tartózkodás hátralévő részére: {amount}. Az összeg a tartózkodás számlájára kerül.',
        add_car_book: 'Foglalás és számlához adás',
        add_car_done: 'A(z) {plate} részére parkolóhely lefoglalva és a tartózkodás számlájához adva.',
    },
    arrival: {
        title: 'Érkezés a szállodába',
        navigate: 'Navigáció',
        back_to_stay: 'Vissza a tartózkodáshoz',
        entrance_title: 'Főbejárat',
        entrance_text: 'Rövid megállás a csomagoknak és lépcsőmentes bejutás.',
        parking_title: 'Kültéri parkoló',
        parking_text: 'Behajtás a saját rendszámával.',
        garage_title: 'Garázsbejárat',
        garage_text: 'A sorompó automatikusan kinyílik, amikor a kamera felismeri a jármű rendszámát.',
    },
    services: {
        room_service_link: 'Szobaszerviz',
        title: 'Szolgáltatások és élmények',
        subtitle: 'A szolgáltatás közvetlenül a tartózkodás számlájához adható.',
        loading: 'Ajánlat betöltése …',
        booked_title: 'MÁR LEFOGLALVA',
        edit: 'Szerkesztés',
        edit_close: 'Szerkesztés bezárása',
        edit_save: 'Módosítás megerősítése',
        edit_hint: 'Válassza ki az új napokat; összefüggő időszak, hézag nélkül.',
        edit_gap: 'Válasszon egymást követő napokat — két külön időszakhoz készítsen két foglalást.',
        edited: 'A foglalás áthelyezve.',
        edit_failed: 'A módosítást nem sikerült végrehajtani — lehet, hogy a napok már foglaltak. Ellenőrizze a listát.',
        desk_only_now: 'Módosítás vagy lemondás már csak a recepción keresztül.',
        withdraw: 'Lemondás',
        withdrawn: 'A foglalás lemondva. Ha már felszámították, az összeg stornózásra került.',
        withdraw_failed: 'A lemondást nem sikerült végrehajtani — kérjük, forduljon a recepcióhoz.',
        policy_until_start: 'Díjmentes lemondás a portálon keresztül a kezdésig.',
        policy_hours: 'Díjmentes lemondás a portálon keresztül a kezdés előtt {hours} órával.',
        policy_desk_only: 'Lemondás csak a recepción keresztül.',
        quantity: 'Mennyi',
        per_days: '/ {days} nap',
        days_count: '{days} nap',
        full_days: 'Foglalt: {days}',
        plate_nth: 'A(z) {number}. jármű rendszáma',
        per_day: '/ nap',
        stay_total: '{amount} {nights} napra',
        book: 'Foglalás a tartózkodásra',
        full: 'A tartózkodására már nincs szabad hely.',
        none: 'A szálloda jelenleg nem kínál a portálon keresztül foglalható szolgáltatásokat. Időpontokért (masszázs, vacsora) forduljon a recepcióhoz.',
        confirm_text: 'Foglalás a teljes tartózkodásra, {from}–{to}. A(z) {amount} összeg a szállodai számlájához adódik.',
        confirm: 'Foglalás megerősítése',
        cancel: 'Mégse',
        needs_plate: 'Adja meg a jármű rendszámát.',
        booked: 'Lefoglalva. A szolgáltatás a tartózkodás számláján szerepel.',
        book_failed: 'A foglalás nem sikerült — próbálja újra, vagy forduljon a recepcióhoz.',
        status_booked: 'lefoglalva',
        status_in_progress: 'folyamatban',
        status_completed: 'teljesítve',
        status_cancelled: 'lemondva',
        status_no_show: 'igénybe nem vett',
    },
    room_service: {
        categories: 'Étlap',
        my_orders: 'Az Ön rendelései',
        basket_open: 'Kosár',
        basket_title: 'Az Ön rendelése',
        when: 'Kiszállítás ideje',
        when_asap: 'Amint lehet',
        when_today: 'Ma {time}-kor',
        when_tomorrow: 'Holnap {time}-kor',
        closed_now_later: 'A konyha most nem szolgál ki — későbbre rendelhet.',
        ordered_at: 'rendelve: {when}',
        deliver_for: 'kiszállítás: {when}',
        ordered_for: 'A rendelés {time}-ra beérkezett — {amount} a szobaszámlán.',
        title: 'Szobaszerviz',
        subtitle: 'Rendeljen a szálloda konyhájából — az összeg a szobaszámlára kerül.',
        loading: 'Étlap betöltése …',
        load_failed: 'Az étlapot nem sikerült betölteni. Ellenőrizze a kapcsolatot, és próbálja újra.',
        retry: 'Újra',
        to_room: 'KISZÁLLÍTÁS A(Z) {room}. SZOBÁBA',
        hours: 'A konyha ma: {hours}',
        shut_today: 'ma zárva',
        closed_now: 'A konyha jelenleg nem fogad rendelést. Kérjük, nyitvatartási időben próbálja.',
        less: 'Egy eltávolítása',
        more: 'Egy hozzáadása',
        empty_menu: 'A szálloda még nem tett semmit az étlapra.',
        basket: 'AZ ÖN RENDELÉSE',
        basket_empty: 'A + gombbal adhat hozzá ételt vagy italt.',
        total: 'Összesen',
        note: 'Üzenet a konyhának',
        note_placeholder: 'pl. hagyma nélkül, két teríték',
        terms: 'A megerősítéskor a konyha megkapja a rendelést, az összeg pedig a szobaszámlára kerül, és kijelentkezéskor kell fizetni.',
        order: 'Rendelés · {amount}',
        sending: 'Küldés …',
        clear: 'Ürítés',
        orders: 'AZ ÖN RENDELÉSEI',
        ordered: 'A rendelés beérkezett — {amount} a szobaszámlán.',
        retry_hint: 'Nem jött válasz. Nyomja meg újra a Rendelés gombot — a rendelés nem duplázódik.',
        failed: 'A konyha nem fogadta el a rendelést. Ellenőrizze, és próbálja újra, vagy hívja a recepciót.',
        not_offered: 'A szálloda ezen a portálon nem kínál szobaszervizt. Rendeléshez hívja a recepciót.',
        not_in_house: 'A szobaszerviz a bejelentkezés után érhető el.',
        menu_unreadable: 'Az étlapot most nem lehet beolvasni. Próbálja újra néhány perc múlva, vagy hívja a recepciót.',
    },
    stay_services: {
        per_appointment: '/ alkalom',
        opens_at_checkin: 'A szállodai időpontokat (masszázs, szauna …) és a közeli partnerek ajánlatait bejelentkezés után foglalhatja le.',
        room: 'Melyik szobához',
        appointments: 'IDŐPONTOK A SZÁLLODÁBAN',
        loading_times: 'Szabad időpontok ellenőrzése …',
        times_failed: 'A szabad időpontokat nem sikerült beolvasni. Kérjük, próbálja újra.',
        departed: 'Tartózkodása véget ért — új időpontot már nem lehet foglalni.',
        no_times: 'Távozásáig nincs szabad időpont.',
        departure_day: 'Az elutazás napján csak a(z) {time}-ig véget érő időpontok választhatók.',
        book: 'Foglalás · {amount}',
        on_bill: 'a szobaszámlára',
        booked: 'Időpont lefoglalva — {amount} a szobaszámlán.',
        book_failed: 'Az időpontot nem sikerült lefoglalni — lehet, hogy épp most foglalták le. Kérjük, válasszon újra.',
        nearby: 'SZOLGÁLTATÁSOK A KÖZELBEN',
        minutes: '{minutes} perc',
        partner_down: 'A partner jelenleg nem válaszol. Próbálja újra néhány perc múlva, vagy kérdezze a recepción.',
        no_times_day: 'A partnernél ezen a napon nincs szabad időpont.',
        partner_terms: 'Az időpontot a(z) {partner} partnernél foglaljuk. A fizetés a szállodával kötött megállapodás szerint történik — a szobaszámlára vagy a partnernél.',
        nearby_done: 'Lefoglalva — várják Önt.',
        taken: 'Ezt az időpontot a partnernél épp most foglalták le. Kérjük, válasszon másikat.',
        nearby_booked: 'IDŐPONTJAI A PARTNEREKNÉL',
        cancel: 'Lemondás',
        cancel_confirm: 'Lemondás megerősítése',
        cancel_changed: 'A lemondás költsége időközben megváltozott.',
        cancel_unknown: 'A lemondásra a(z) {partner} feltételei vonatkozhatnak — a költségről érdeklődjön a recepción, vagy erősítse meg a lemondást.',
        cancel_late: 'Késői lemondás: a partner {amount} összeget számít fel a szobájára.',
        cancel_late_free: 'Az ingyenes lemondás határideje lejárt, de a partner ezért a szolgáltatásért nem számít fel semmit.',
        cancel_free: 'A lemondás {deadline}-ig ingyenes.',
        cancel_gone: 'Ez az időpont itt már nem mondható le. Kérdezze a recepción.',
        cancelled: 'Az időpont lemondva.',
        cancelled_fee: 'Az időpont lemondva. A partner {amount} összeget számít fel a szobaszámlára.',
        cancel_failed: 'A lemondás nem sikerült. Próbálja újra, vagy kérdezze a recepción.',
    },
    order_pin: {
        title: 'Rendelési PIN-kód',
        hint: 'A szálloda rendelés vagy foglalás előtt kéri PIN-kódját. Bejelentkezéskor kapta a recepción vagy e-mailben.',
        label: 'PIN',
        confirm: 'Megerősítés',
        wrong: 'A PIN-kód nem megfelelő. Kérjük, próbálja újra.',
        locked: 'Túl sok hibás próbálkozás. Próbálja újra néhány perc múlva, vagy kérdezze a recepción.',
    },
    payment_done: {
        paid_title: 'Sikeres fizetés',
        paid_text: 'Köszönjük! A fizetés megtörtént — a recepció néhány másodpercen belül könyvelve látja.',
        cancelled_title: 'A fizetés nem történt meg',
        cancelled_text: 'Semmilyen terhelés nem történt. Új próbálkozáshoz kérje a recepciót.',
    },
    payments: {
        details_open: 'Rendelés megtekintése',
        details_total: 'Összesen',
        details_tax: 'ebből ÁFA {rate} %: {amount}',
        title: 'Fizetések és számlák',
        reservation: '{number}. foglalás',
        open_badge: 'Nyitott',
        folio_title: 'A tartózkodás számlája',
        due: 'Fizetendő',
        pay_starting: 'Fizetés megnyitása …',
        pay_failed: 'A fizetést nem sikerült elindítani — próbálja újra, vagy forduljon a recepcióhoz.',
        paid_message: 'A fizetés sikerült. Köszönjük!',
        method_cash: 'készpénz',
        method_card: 'kártya',
        method_transfer: 'átutalás',
        method_voucher: 'utalvány',
        method_prepayment: 'előleg',
        method_ota_virtual_card: 'virtuális kártya',
        processing_title: 'Fizetés feldolgozása',
        processing_text: 'Várjuk a fizetési szolgáltató visszaigazolását. Ez általában néhány másodpercet vesz igénybe — az oldal jelezni fogja, amint a fizetés könyvelve lett.',
        processing_timeout: 'Még nincs visszaigazolás. Ha a fizetés megtörtént, hamarosan megjelenik a tételek között — egyébként forduljon a recepcióhoz.',
        overpaid_message: 'A befizetett összeg magasabb a fizetendőnél — a különbözetet a recepció jóváírásként rendezi.',
        cancelled_message: 'A fizetés megszakítva.',
        settled_badge: 'Rendezve',
        stripe_note: 'A kártyát a Stripe biztonságos oldalán adja meg; a szálloda nem látja és nem tárolja a kártyaadatokat. Tesztkörnyezet.',
        pay_now: 'Fizetés most',
        proforma: 'Díjbekérő letöltése',
        proforma_failed: 'A díjbekérőt nem sikerült előkészíteni — próbálja újra.',
        invoices: 'Számlák',
        invoices_text: 'A végleges számla a tartózkodás lezárása után lesz elérhető.',
        documents: 'Dokumentumok',
        no_invoice_yet: 'A végleges számla még nem került kiállításra.',
        secure_title: 'Biztonságos fizetés',
        secure_text: 'A kártyaadatokat sem a szálloda, sem az Imprion nem tárolja.',
        pay_title: 'Fizetés: {amount}',
        simulated: 'Szimulált fizetés — a kártyáját nem terheljük meg.',
        simulated_done: 'Ez szimuláció volt — az online fizetés az egyik következő verzióban érkezik.',
        cardholder: 'Kártyabirtokos',
        card_number: 'Kártyaszám',
        expiry_cvc: 'Lejárat / CVC',
        pay_secure: 'Biztonságos fizetés',
    },
    studio: {
        button: 'Portál testreszabása',
        title: 'Szállodai portál testreszabása',
        hint: 'Előnézet egy adott létesítmény beállításához. Az Imprion Guest továbbra is a portál szolgáltatójaként marad megjelölve.',
        primary: 'Fő szín',
        accent: 'Kiemelő szín',
        compact: 'szögletesebb elemek',
        preview_only: 'Csak előnézet — a szálloda megjelenését a recepció menti.',
    },
    license: {
        eyebrow: 'Online bejelentkezés',
        title: 'Ez a szolgáltatás nincs bekapcsolva',
        lead: 'Ez a szálloda nem kapcsolta be az online bejelentkezést, ezért ez a portál nem nyitható meg. A foglalása ettől semmiben nem változik.',
        another_link: 'Ha időközben másik hivatkozást kapott, egyszerűen nyissa meg — ez az oldal újratöltődik.',
        contact: 'A tartózkodásával kapcsolatos bármely kérdéssel forduljon a szálloda recepciójához — szívesen segítenek.',
    },
    memory: {
        eyebrow: 'Emlék a tartózkodásról',
        thanks: 'Köszönjük a látogatást',
        lead: 'Örömünkre szolgált a vendéglátás. Itt marad egy rövid emlék a tartózkodásáról.',
        stayed: 'Tartózkodás',
        room: 'Szoba',
        used: 'Amit igénybe vett',
        nights: 'Éjszakák',
        nights_one: '{n} éjszaka',
        nights_two: '{n} éjszaka',
        nights_few: '{n} éjszaka',
        nights_many: '{n} éjszaka',
        guests: 'Vendégek',
        guests_one: '{n} fő',
        guests_two: '{n} fő',
        guests_few: '{n} fő',
        guests_many: '{n} fő',
        book_again: 'Foglaljon újra',
        invoice: 'Kérem a számlát e-mailben',
        invoice_sending: 'Küldés folyamatban…',
        invoice_sent: 'A számlát elküldtük az Ön által megadott e-mail-címre.',
        invoice_failed: 'A számlát most nem sikerült elküldeni. Próbálja később, vagy írjon a szállodának.',
        privacy: 'Ez az oldal nyitva marad, és nem tartalmaz személyes adatokat.',
    },
    invalid: {
        demo_opening: 'A tartózkodás megnyitása …',
        hotel_fallback: 'Az Ön szállodája',
        reception: 'Recepció',
        eyebrow: 'Új hivatkozásra van szüksége?',
        title: 'Semmi gond — gyorsan elintézzük',
        text: 'Biztonsági okokból ez a hivatkozás már nem érvényes. A foglalása ettől nem került lemondásra, és semmilyen adat nem veszett el.',
        help_title: 'Hogyan tovább',
        step_contact_title: 'Forduljon a recepcióhoz',
        step_contact_text: 'Hívja fel a szállodát, vagy küldjön nekik egy rövid üzenetet.',
        step_identify_title: 'Mondja meg, melyik tartózkodásról van szó',
        step_identify_text: 'Elég a vendég neve és a várható érkezés dátuma.',
        step_open_title: 'Nyissa meg az új hivatkozást',
        step_open_text: 'A szálloda e-mailben vagy üzenetben elküldi Önnek.',
        retry: 'Próbálja újra',
        security: 'A hivatkozásokat időben korlátozzuk, hogy megvédjük a tartózkodása adatait.',
    },
    /*
     * Hiša — vsebina sobnih televizorjev na telefonu (docs/DISPLAY.md §9).
     *
     * Svoj imenski prostor, ker je to stavba in ne bivanje: isto besedilo vidi vsak gost
     * v hiši, ne glede na svojo rezervacijo. Izrazje je namenoma isto kot na zaslonih
     * (`house.*`, `local.kind_*` v pms-display), da hiša na steni in na telefonu ne
     * govori dveh jezikov.
     */
    house: {
        sign_up: 'Feliratkozunk',
        signed_up: 'Feliratkozva',
        signup_count: '{count} feliratkozott',
        guest_deal: 'Szállóvendégeknek: {deal}',
        voucher_title: 'Az Ön kedvezménykuponja',
        voucher_open: 'Kupon megnyitása',
        voucher_note: 'Mutassa be a QR-kódot, vagy nyissa meg a hivatkozást a partnernél — az oldal élőben igazolja, hogy Ön a szálloda vendége.',
        locked_eye: 'Bejelentkezéskor oldódik fel',
        locked_text: 'A szálloda tartalmai — Wi-Fi, üdvözlőlevél, program és környék — a telefonján a bejelentkezéskor oldódnak fel. Találkozunk a recepción!',
        title: 'A szálloda',
        loading: 'Betöltés …',
        failed: 'A szálloda tartalma jelenleg nem jeleníthető meg. Próbálja újra néhány pillanat múlva.',
        section_house: 'ÜDVÖZÖLJÜK',
        section_letter: 'ÜDVÖZLŐLEVÉL',
        section_today: 'MA A SZÁLLODÁBAN',
        section_weather: 'IDŐJÁRÁS',
        section_services: 'SZOLGÁLTATÁSOK ÉS ÁRLISTA',
        section_events: 'ESEMÉNYEK A KÖRNYÉKEN',
        section_places: 'LÁTNIVALÓK A KÖRNYÉKEN',
        wifi: 'Vezeték nélküli hálózat',
        network: 'Hálózat',
        password: 'Jelszó',
        wifi_open: 'A hálózat nyitott, nincs szükség jelszóra.',
        hours: 'Nyitvatartás',
        phone_keys: 'Telefongombok',
        room_phone: 'A szobai telefonról.',
        emergency: 'Segélyhívás',
        per_day: '/ nap',
        per_item: '/ egyszeri',
        to_services: 'Szolgáltatás foglalása',
        open_in_maps: 'Megnyitás a Google Térképen',
        kind_sight: 'Látnivaló',
        kind_restaurant: 'Hol együnk',
        kind_activity: 'Program',
        kind_shop: 'Vásárlás',
        kind_other: 'Egyéb a környéken',
    },
    /* Napoved je Open-Meteo; `weather` je beseda za nebo, ki jo prevede zaslon. */
    weather: {
        today: 'ma',
        rain_chance: '{percent} %',
        clear: 'derült',
        partly_cloudy: 'részben felhős',
        overcast: 'borult',
        fog: 'köd',
        drizzle: 'szitálás',
        rain: 'eső',
        rain_showers: 'záporok',
        snow: 'hó',
        snow_showers: 'hózáporok',
        thunderstorm: 'zivatar',
    },
    /*
     * Milo, the house's assistant in the guest's own hands.
     *
     * Short sentences on purpose: this is read on a telephone, standing up, usually with
     * one hand. `executed` says "handed over" and never "done" — every one of the four
     * actions is a REQUEST the hotel then acts on, and a portal that said "done" would
     * be promising on the hotel's behalf.
     *
     * `result.*` is what a confirmed proposal DID, keyed by the outcome code the service
     * sends. The Slovenian 1/2/3-4/5+ forms are chosen in `libs/chatResult.ts` and not by
     * vue-i18n, for the reason written there; the other languages carry the same four
     * keys so that the two locale files never disagree about which keys exist.
     */
    milo: {
        title: 'Milo',
        greeting: 'Üdvözlöm, Milo vagyok.',
        intro: 'Kérdezzen a szállodáról és a tartózkodásáról — az Ön nyelvén válaszolok.',
        placeholder: 'Írja le a kérdését …',
        send: 'Küldés',
        thinking: 'Milo gondolkodik …',
        still_working: 'Még keresem — ez eltarthat egy percig.',
        disclaimer: 'Milo a szálloda asszisztense. Fizetést nem fogad el és számlát nem állít ki; minden másban a recepció áll rendelkezésére.',
        open: 'Milo megnyitása',
        close: 'Bezárás',
        chip_wifi: 'Wi-Fi',
        chip_wifi_text: 'Mi a Wi-Fi jelszó?',
        chip_breakfast: 'Reggeli',
        chip_breakfast_text: 'Meddig tart a reggeli?',
        chip_late_checkout: 'Késői kijelentkezés',
        chip_late_checkout_text: 'Maradhatok kicsit tovább a szobában?',
        chip_today: 'Mi történik ma',
        chip_today_text: 'Mi történik ma a környéken?',
        confirm: 'Megerősítem',
        decline: 'Nem, most nem',
        executed: 'Elküldve',
        declined: 'Nem lett elküldve.',
        failed: 'Nem sikerült. Próbálja újra, vagy hívja a recepciót.',
        expired: 'Ez a javaslat lejárt. Kérdezzen újra.',
        already_decided: 'Erről a javaslatról már döntés született.',
        card_closed: 'Ez a javaslat már nem hagyható jóvá.',
        budget_spent: 'Mára elég a kérdésekből. Holnap újra, vagy hívja a recepciót.',
        throttled: 'Egy pillanat — próbálja újra néhány másodperc múlva.',
        too_long: 'Milónak túl sokáig tartott ez a kérdés. Kérdezzen valami konkrétabbat, vagy hívja a recepciót.',
        interrupted: 'Milót válaszadás közben megszakították. Kérjük, kérdezze meg még egyszer.',
        unavailable: 'Milo jelenleg nem érhető el. A recepció készséggel segít.',
        result: {
            late_checkout_requested:    'A késői kijelentkezésre vonatkozó kérése a recepciónál van.',
            guest_service_booked_one:   'Lefoglalva {count} napra.',
            guest_service_booked_two:   'Lefoglalva {count} napra.',
            guest_service_booked_few:   'Lefoglalva {count} napra.',
            guest_service_booked_other: 'Lefoglalva {count} napra.',
            room_request_raised:        'A kérése a takarítószolgálatnál van.',
            reception_message_sent:     'Az üzenete a recepciónál van.',
            room_service_ordered_one:   'A konyhánál van a rendelése: {count} tétel, {detail}.',
            room_service_ordered_two:   'A konyhánál van a rendelése: {count} tétel, {detail}.',
            room_service_ordered_few:   'A konyhánál van a rendelése: {count} tétel, {detail}.',
            room_service_ordered_other: 'A konyhánál van a rendelése: {count} tétel, {detail}.',
            lost_item_reported:         'A bejelentése {detail} számon van rögzítve; a recepció értesíti Önt.',
            transfer_requested:         'A transzferkérése ({detail}) a recepciónál van.',
        },
    },
}
